var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2293_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2461 16.17L19.5061 20.34L18.7561 19.65L20.7661 17.04H11.2261L13.2361 19.65L12.4861 20.34L7.74609 16.17L12.4861 12L13.2361 12.69L11.2261 15.3H20.7661L18.7561 12.69L19.5061 12L24.2461 16.17Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.875,
    width: 30.25,
    height: 30.25,
    stroke: "currentcolor",
    strokeWidth: 1.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2293_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitation);
export default __webpack_public_path__ + "static/media/citation.688272b2a56346ab6608ddc4f07438c4.svg";
export { ForwardRef as ReactComponent };